export const pushToGTM = (category, action, label) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "DQCS",
      category: category,
      action: action,
      label: {
        appName: "track-and-trace",
        ...label
      }
    });
  } else {
    console.warn("GTM dataLayer is not available.");
  }
};

export const appButtonClick = (feature, subFeature, terminalID, metaData) => {
  pushToGTM("click", "button-click", {
    feature: feature,
    subFeature: subFeature,
    terminalId: "Global",
    metaData: metaData
  });
};

export const deviceInfo = (deviceData) => {
  pushToGTM("ui-tracking", "device_info", {
    feature: "device_info",
    subFeature: "Device Info",
    terminalId: "Global",
    metaData: {
      deviceType: deviceData
    }
  });
};

export const setSessionUser = (userData) => {
  pushToGTM("set_user", "session_user", {
    feature: "session_user",
    subFeature: "Session User",
    terminalId: "Global",
    metaData: userData
  });
};

export const fetchApiInfo = (feature, subFeature, terminalID, apiData) => {
  pushToGTM("api-tracking", "fetch_api", {
    feature: feature,
    subFeature: subFeature,
    terminalId: "Global",
    metaData: apiData
  });
};
